import React from 'react';
import FlyoutSwitch, {FORECASTING_FLYOUT_MODE} from '../common/FlyoutSwitch';

const FlyoutVectors = () => {
	return <FlyoutSwitch startMode={FORECASTING_FLYOUT_MODE.VECTOR_LIST} />;
};

export default FlyoutVectors;
